import { z } from 'zod';

export const FAQModelSchema = z.object({
    uid: z.string(),
    question: z.string(),
    answer: z.any().optional(),
});

export type FAQModel = z.infer<typeof FAQModelSchema>;
